'use strict';

const SHOW_CUSTOMIZE_MODAL = "customize/SHOW_CUSTOMIZE_MODAL";
const HIDE_CUSTOMIZE_MODAL = "customize/HIDE_CUSTOMIZE_MODAL";
const TOGGLE_ADDON = "customize/TOGGLE_ADDON";
const UPDATE_VARIANT = "customize/UPDATE_VARIANT";
const NEXT_STEP = "customize/NEXT_STEP";
const CHANGE_STEP = "customize/CHANGE_STEP";

exports.CHANGE_STEP = CHANGE_STEP;
exports.HIDE_CUSTOMIZE_MODAL = HIDE_CUSTOMIZE_MODAL;
exports.NEXT_STEP = NEXT_STEP;
exports.SHOW_CUSTOMIZE_MODAL = SHOW_CUSTOMIZE_MODAL;
exports.TOGGLE_ADDON = TOGGLE_ADDON;
exports.UPDATE_VARIANT = UPDATE_VARIANT;
//# sourceMappingURL=types.js.map
